module.exports = __webpack_public_path__ + "img/home_pickleball.30bfcad4.jpg";